'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: 'Seleccionar hora'
};
exports['default'] = locale;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/time-picker/locale/ca_ES.js
// module id = 600
// module chunks = 0